import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _seoProjectToSiteId;

import { Sites } from "../../config/sites";
/** @deprecated TODO: to be replaced by Sites */

export var SeoProject;
/** Temporary object to convert seo project to Site Id  */

(function (SeoProject) {
  SeoProject["AUFEMININ_COM"] = "aufeminin.com";
  SeoProject["ENFEMENINO_COM"] = "enfemenino.com";
  SeoProject["ALFEMMINILE_COM"] = "alfeminile.com";
  SeoProject["GOFEMININ_DE"] = "gofeminin.de";
  SeoProject["SOFEMININE_CO_UK"] = "sofeminine.co.uk";
  SeoProject["WEWOMEN_BE"] = "wewomen.be";
  SeoProject["TAOFEMININO_COM_BR"] = "taofeminino.com.br";
  SeoProject["MARMITON_ORG"] = "marmiton.org";
  SeoProject["NETMUMS_COM"] = "netmums.com";
  SeoProject["DOCTISSIMO_FR"] = "doctissimo.fr";
  SeoProject["TEST"] = "test";
})(SeoProject || (SeoProject = {}));

export var seoProjectToSiteId = (_seoProjectToSiteId = {}, _defineProperty(_seoProjectToSiteId, SeoProject.AUFEMININ_COM, Sites.AUFEMININ_COM), _defineProperty(_seoProjectToSiteId, SeoProject.ENFEMENINO_COM, Sites.ENFEMENINO_COM), _defineProperty(_seoProjectToSiteId, SeoProject.ALFEMMINILE_COM, Sites.ALFEMMINILE_COM), _defineProperty(_seoProjectToSiteId, SeoProject.GOFEMININ_DE, Sites.GOFEMININ_DE), _defineProperty(_seoProjectToSiteId, SeoProject.SOFEMININE_CO_UK, Sites.SOFEMININE_CO_UK), _defineProperty(_seoProjectToSiteId, SeoProject.WEWOMEN_BE, Sites.WEWOMEN_BE), _defineProperty(_seoProjectToSiteId, SeoProject.TAOFEMININO_COM_BR, Sites.TAOFEMININO_COM_BR), _defineProperty(_seoProjectToSiteId, SeoProject.MARMITON_ORG, Sites.MARMITON_ORG), _defineProperty(_seoProjectToSiteId, SeoProject.NETMUMS_COM, Sites.NETMUMS_COM), _defineProperty(_seoProjectToSiteId, SeoProject.DOCTISSIMO_FR, Sites.DOCTISSIMO_FR), _defineProperty(_seoProjectToSiteId, SeoProject.TEST, Sites.TEST), _seoProjectToSiteId);